var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"bg-gray-100 flex-grow"},[_c('div',{staticClass:"w-full max-w-lg relative mx-auto py-8 sm:py-16 px-4"},[_c('CandidateMagicLink')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }